import { render } from "./RecentFiles.vue?vue&type=template&id=43ad844a&ts=true"
import script from "./RecentFiles.vue?vue&type=script&lang=ts"
export * from "./RecentFiles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__